/* eslint-disable no-nested-ternary */
// @flow
import React, { type ComponentType } from 'react';
import styled from 'styled-components';
import Base from './Base';

type TypographyTypes = {
  Base: ComponentType<*>,
  h2: ComponentType<*>,
  h3: ComponentType<*>,
  h4: ComponentType<*>,
  h5: ComponentType<*>,
  h6: ComponentType<*>,
  p: ComponentType<*>,
  errorSpan: ComponentType<*>,
  successSpan: ComponentType<*>
};

const config = {
  fontSize: {
    h2: 2.4,
    h3: 1.8,
    h4: 1.7,
    h5: 1.5,
    h6: 1.4,
    p: 1.6,
    errorSpan: 1,
    successSpan: 1
  }
};

const Typography: TypographyTypes = {};

Typography.Base = styled(
  ({
    flex,
    fontSize,
    title,
    color,
    bold,
    p,
    pt,
    pr,
    pb,
    pl,
    m,
    mt,
    mr,
    mb,
    ml,
    b,
    bt,
    br,
    bb,
    bl,
    justify,
    ...props
  }) => <Base {...props} />
).attrs(props => ({
  block: !props.block
}))`
  font-size: ${({ fontSize, component }) => fontSize / 10 || config.fontSize[component]}rem;
  color: ${({ title, color }) => (title ? `var(--colorSystemInfo)` : color || `var(--colorDefault)`)};
  font-weight: ${({ bold }) => (typeof bold == 'boolean' && bold ? `600` : typeof bold == 'number' ? bold : `400`)};
  ${({ p }) => p && `padding: calc(${p} * var(--spacing))`};
  ${({ pt }) => pt && `padding-top: calc(${pt} * var(--spacing))`};
  ${({ pr }) => pr && `padding-right: calc(${pr} * var(--spacing))`};
  ${({ pb }) => pb && `padding-bottom: calc(${pb} * var(--spacing))`};
  ${({ pl }) => pl && `padding-left: calc(${pl} * var(--spacing))`};
  ${({ px }) => px && `padding-left: calc(${px} * var(--spacing)); padding-right: calc(${px} * var(--spacing))`};
  ${({ py }) => py && `padding-top: calc(${py} * var(--spacing)); padding-bottom: calc(${py} * var(--spacing))`};
  text-align: ${({ justify }) => (justify ? `justify` : `left`)};

  ${({ m }) => m && `margin: calc(${m} * var(--spacing))`};
  ${({ mt }) => mt && `margin-top: calc(${mt} * var(--spacing))`};
  ${({ mr }) => mr && `margin-right: calc(${mr} * var(--spacing))`};
  ${({ mb }) => mb && `margin-bottom: calc(${mb} * var(--spacing))`};
  ${({ ml }) => ml && `margin-left: calc(${ml} * var(--spacing))`};
  ${({ mx }) => mx && `margin-left: calc(${mx} * var(--spacing)); margin-right: calc(${mx} * var(--spacing))`};
  ${({ my }) => my && `margin-top: calc(${my} * var(--spacing)); margin-bottom: calc(${my} * var(--spacing))`};

  ${({ b }) => b && `border: ${b}px solid var(--borderDefault)`};
  ${({ bt }) => bt && `border-top: ${bt}px solid var(--borderDefault)`};
  ${({ br }) => br && `border-right: ${br}px solid var(--borderDefault)`};
  ${({ bb }) => bb && `border-bottom: ${bb}px solid var(--borderDefault)`};
  ${({ bl }) => bl && `border-left: ${bl}px solid var(--borderDefault)`};
`;

Typography.h2 = styled(Typography.Base).attrs({ component: 'h2' })`
  font-weight: 700;
  line-height: 2.8;
`;

Typography.h3 = styled(Typography.Base).attrs({ component: 'h3' })`
  /* font-family: 'Lato', sans-serif; */
  font-weight: 600;
  line-height: 1.04;
`;
Typography.h4 = styled(Typography.Base).attrs({ component: 'h4' })`
  /* font-family: 'Lato', sans-serif; */
  font-weight: 600;
  line-height: 1.04;
`;
Typography.h5 = styled(Typography.Base).attrs({ component: 'h5' })`
  /* font-family: 'Lato', sans-serif; */
  font-weight: 600;
  line-height: 1.04;
`;
Typography.h6 = styled(Typography.Base).attrs({ component: 'h6' })`
  /* font-family: 'Lato', sans-serif; */
  font-weight: 600;
  line-height: 1.04;
`;

Typography.p = styled(Typography.Base).attrs({ component: 'p' })`
  line-height: 1.5;
`;
Typography.errorSpan = styled(Typography.Base).attrs({ component: 'span' })`
  line-height: 1.5;
  color: red;
  display: inline-block !important;
`;
Typography.successSpan = styled(Typography.Base).attrs({ component: 'span' })`
  line-height: 1.5;
  color: #0cce6b;
  display: inline-block !important;
`;

export default Typography;
